import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthenticationState, authenticationFeatureKey } from 'src/app/authentication/state/authentication.reducer';
import { Reports } from '../reports.enum';
import { EffectiveReports } from './effective-reports';

const authenticationFeatureSelector = createFeatureSelector<AuthenticationState>(authenticationFeatureKey);

export function hasSelectedReport(report: Reports, userId: number | null, effectiveReports: EffectiveReports[]) {
   if (userId !== null && effectiveReports) {
      return effectiveReports.some((rep) => rep.UserId === userId && rep.Report === report);
   }
   return false;
}
export const selectReports = createSelector(authenticationFeatureSelector, (state) => {
   return state.effectiveReports;
});
